import addressEN from "./address.json";
import broadbandLoginEN from "./broadbandLogin.json";
import cartEN from "./cart.json";
import commonEN from "./common.json";
import confirmationEN from "./confirmation.json";
import controlEN from "./control.json";
import customerDetailsEN from "./customerDetails.json";
import footerEN from "./footer.json";
import glossaryEN from "./glossary.json";
import headerEN from "./header.json";
import homeEN from "./home.json";
import marketingPreferencesEN from "./marketingPreferences.json";
import portinEN from "./portin.json";
import selectReasonEN from "./selectReason.json";
import summaryEN from "./summary.json";
import validationEN from "./validation.json";
import eSimEN from "./eSim.json";
import installationEN from "./installation.json";

export const address = addressEN;

export const broadbandLogin = broadbandLoginEN;

export const cart = cartEN;

export const common = commonEN;

export const confirmation = confirmationEN;

export const control = controlEN;

export const customerDetails = customerDetailsEN;

export const footer = footerEN;

export const glossary = glossaryEN;

export const header = headerEN;

export const home = homeEN;

export const marketingPreferences = marketingPreferencesEN;

export const portin = portinEN;

export const selectReason = selectReasonEN;

export const summary = summaryEN;

export const validation = validationEN;

export const eSim = eSimEN;

export const installation = installationEN;
